import React from "react";

export const ReportsPage = () => {
  return (
    <section className="rounded-3xl border border-dashed border-slate-300/80 bg-white/75 p-10 text-center shadow-inner shadow-white/30">
      <h1 className="text-3xl font-semibold text-slate-900">Reports</h1>
      <p className="mt-4 text-sm text-slate-500">
        Your reports will live here. Hang tight - we're still building it.
      </p>
    </section>
  );
};

export default ReportsPage;
